import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgPersonalInfo({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.6 9.7c0 2.146-1.988 3.843-4.27 3.44-1.63-.286-2.93-2.002-2.93-3.612V8.471c0-1.61 1.3-3.326 2.93-3.612 2.282-.401 4.27 1.294 4.27 3.441v1.4ZM3.82 20.072c1.335-2.593 4.497-4.42 8.18-4.42 3.684 0 6.845 1.827 8.181 4.42 0 0-2.442 2.78-8.181 2.78-5.74 0-8.18-2.78-8.18-2.78Z"
                fill="currentColor"
            />
            <path
                d="M23 12c0 6.076-4.925 11-11 11S1 18.076 1 12 5.925 1 12 1s11 4.924 11 11Z"
                stroke="#297A71"
                strokeWidth={2}
            />
        </svg>
    )
}
SvgPersonalInfo.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgPersonalInfo
